// extracted by mini-css-extract-plugin
export default {"CustomTag":"CustomTag_CustomTag__b9EKT","text":"CustomTag_text__oun6T"};